<template>
  <div class="vcr-guide-page" v-if="guideShow" @click.stop="nextStep">
    <div class="step-1-indicator" v-if="curStep==1" :style="'top:'+bossBtm+'px'">
      <div class="holder"></div>
      <div class="indicator"></div>
    </div>
    <div class="step-2-indicator" v-if="curStep==2" :style="'top:calc( '+anchorBtm+'px - 0.72rem )'">
      <div class="holder"></div>
      <div class="indicator"></div>
    </div>
  </div>
</template>

<script>
  import {localSave} from "../../utils/tools";
  import global from "../../config/global";

  export default {
    name: "vcrguide",
    data() {
      return {
        curStep: 0,
      }
    },
    props: {
      guideShow: false,
      bossBtm: 0,
      anchorBtm: 0,
    },
    methods: {
      hideSelf() {
        this.$emit('hideVCRGuide')
        localSave(global.getUserDisplay()+'_show_vcr_guide',true)
      },
      nextStep() {
        if (++this.curStep > 2) {
          this.hideSelf()
        }
      },
    },
    computed: {},
    watch: {
      guideShow(n, o) {
        console.log('vcrguide-com:' + n)
        if (n) {
          this.curStep = 0
          this.nextStep()
        }
      }
    }
  }
</script>

<style lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .vcr-guide-page {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(0, 0, 0, .5);

    .step-1-indicator {
      position: absolute;
      .w(618);
      .h(480);
      left: 50%;
      transform: translateX(calc(-50% - .52rem));

      .holder {
        .w(188);
        .h(192);
        .left(354);
        position: absolute;
        background: url(../../assets/imgs/newvcr/img_boss.png) no-repeat;
        background-size: contain;
      }

      .indicator {
        .top(174);
        .w(618);
        .h(306);
        background: url(../../assets/imgs/newvcr/guide_1.png) no-repeat;
        background-size: contain;
        position: absolute;
      }

    }

    .step-2-indicator {
      position: absolute;
      .left(60);
      .w(618);
      .h(343);

      .holder {
        .w(100);
        .h(44);
        .left(15);
        position: absolute;
        background: url(../../assets/imgs/btn_call.png) no-repeat;
        background-size: contain;
      }

      .indicator{
        .w(618);
        .h(306);
        .top(37);
        top: v-bind(bossBtm);
        background: url(../../assets/imgs/guide_2.png) no-repeat;
        background-size: contain;
        position: absolute;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/vcrguide.vue